import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import success from '../../../assets/images/backoffice/kyc6.png';
import { CreditCard } from '../../../components/common/CreditCard';
import { Hub } from '../../../components/common/Hub/Hub';
import {
  copyLink,
  formatUSD,
  showNetworkType,
  showTokenType,
  USDT
} from '../../../helpers/helperFunctions';
import { ORDERS } from '../../../routes/routes';
import { CaptionText, H2, H3, P3, P1 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconCopy } from '../../../styles/Icons';
import { NetworkType } from '../../../types/types';
import { SelectedUSDT } from '../Marketplace.styled';
import { Node } from '../../../components/common/Node/Node';
import basic from '../../../assets/images/backoffice/entryPackages/basic.jpg';

interface SuccessProps {
  selectedPackage: any;
}

export const Success = ({ selectedPackage }: SuccessProps) => {
  const { t } = useTranslation('marketplace');
  const history = useHistory();

  return (
    <>
      <>
        <Node
          key={selectedPackage?.id}
          condensed
          showTickets={false}
          image={basic}
          title={selectedPackage?.name}
          price={selectedPackage?.price}
          packagePrice={selectedPackage?.price}
          info={<></>}
        />
        <Flexed justifyCenter>
          <img src={success} alt='success' style={{ width: 150 }} />
        </Flexed>
        <H3 center mb='5' mt='40' color={color.colors.neutral900}>
          Success!
        </H3>
        <P3 center color={color.colors.neutral500}>
          Your Entry Package is purchased successfully!
        </P3>
      </>

      <Flexed justifyCenter mt='40'>
        <Button
          onClick={() => {
            history.push(ORDERS);
          }}>
          {t('close_button')}
        </Button>
      </Flexed>
    </>
  );
};
